// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file ai_color_simulation/v1/al_color_service.proto (package ai_color_simulation.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProcessImageColorResponseSchema, ProcessImageRequestSchema, WarmUpRequestSchema, WarmUpResponseSchema } from "./messages_pb";
import { file_ai_color_simulation_v1_messages } from "./messages_pb";
import type { CreateProcessImageDealRequestSchema, CreateProcessImageProjectRequestSchema, CreateProcessImageProjectResponseSchema, GenerateMaskRequestSchema, GenerateMaskResponseSchema, UploadProcessImageRequestSchema, UploadProcessImageResponseSchema } from "./process_image_pb";
import { file_ai_color_simulation_v1_process_image } from "./process_image_pb";

/**
 * Describes the file ai_color_simulation/v1/al_color_service.proto.
 */
export const file_ai_color_simulation_v1_al_color_service: GenFile = /*@__PURE__*/
  fileDesc("Ci1haV9jb2xvcl9zaW11bGF0aW9uL3YxL2FsX2NvbG9yX3NlcnZpY2UucHJvdG8SFmFpX2NvbG9yX3NpbXVsYXRpb24udjEy5AUKGEFsQ29sb3JTaW11bGF0aW9uU2VydmljZRKDAQoWQ3JlYXRlUHJvY2Vzc0ltYWdlRGVhbBI1LmFpX2NvbG9yX3NpbXVsYXRpb24udjEuQ3JlYXRlUHJvY2Vzc0ltYWdlRGVhbFJlcXVlc3QaMi5haV9jb2xvcl9zaW11bGF0aW9uLnYxLlVwbG9hZFByb2Nlc3NJbWFnZVJlc3BvbnNlEpABChlDcmVhdGVQcm9jZXNzSW1hZ2VQcm9qZWN0EjguYWlfY29sb3Jfc2ltdWxhdGlvbi52MS5DcmVhdGVQcm9jZXNzSW1hZ2VQcm9qZWN0UmVxdWVzdBo5LmFpX2NvbG9yX3NpbXVsYXRpb24udjEuQ3JlYXRlUHJvY2Vzc0ltYWdlUHJvamVjdFJlc3BvbnNlEnsKElVwbG9hZFByb2Nlc3NJbWFnZRIxLmFpX2NvbG9yX3NpbXVsYXRpb24udjEuVXBsb2FkUHJvY2Vzc0ltYWdlUmVxdWVzdBoyLmFpX2NvbG9yX3NpbXVsYXRpb24udjEuVXBsb2FkUHJvY2Vzc0ltYWdlUmVzcG9uc2USbgoMUHJvY2Vzc0ltYWdlEisuYWlfY29sb3Jfc2ltdWxhdGlvbi52MS5Qcm9jZXNzSW1hZ2VSZXF1ZXN0GjEuYWlfY29sb3Jfc2ltdWxhdGlvbi52MS5Qcm9jZXNzSW1hZ2VDb2xvclJlc3BvbnNlEmkKDEdlbmVyYXRlTWFzaxIrLmFpX2NvbG9yX3NpbXVsYXRpb24udjEuR2VuZXJhdGVNYXNrUmVxdWVzdBosLmFpX2NvbG9yX3NpbXVsYXRpb24udjEuR2VuZXJhdGVNYXNrUmVzcG9uc2USVwoGV2FybVVwEiUuYWlfY29sb3Jfc2ltdWxhdGlvbi52MS5XYXJtVXBSZXF1ZXN0GiYuYWlfY29sb3Jfc2ltdWxhdGlvbi52MS5XYXJtVXBSZXNwb25zZUI9WjtnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYWlfY29sb3Jfc2ltdWxhdGlvbi92MTthcGl2MWIGcHJvdG8z", [file_ai_color_simulation_v1_messages, file_ai_color_simulation_v1_process_image]);

/**
 * @generated from service ai_color_simulation.v1.AlColorSimulationService
 */
export const AlColorSimulationService: GenService<{
  /**
   * 画像のアップロードと案件（プロジェクト）の作成を行う
   *
   * @generated from rpc ai_color_simulation.v1.AlColorSimulationService.CreateProcessImageDeal
   */
  createProcessImageDeal: {
    methodKind: "unary";
    input: typeof CreateProcessImageDealRequestSchema;
    output: typeof UploadProcessImageResponseSchema;
  },
  /**
   * deal を作らず AIカラープロジェクトを作成し、画像を一次加工して保存する (issue #1828)
   *
   * @generated from rpc ai_color_simulation.v1.AlColorSimulationService.CreateProcessImageProject
   */
  createProcessImageProject: {
    methodKind: "unary";
    input: typeof CreateProcessImageProjectRequestSchema;
    output: typeof CreateProcessImageProjectResponseSchema;
  },
  /**
   * 既存の案件に対して画像のアップロードのみを行う
   *
   * @generated from rpc ai_color_simulation.v1.AlColorSimulationService.UploadProcessImage
   */
  uploadProcessImage: {
    methodKind: "unary";
    input: typeof UploadProcessImageRequestSchema;
    output: typeof UploadProcessImageResponseSchema;
  },
  /**
   * アップロード済みの画像の加工を行う
   *
   * @generated from rpc ai_color_simulation.v1.AlColorSimulationService.ProcessImage
   */
  processImage: {
    methodKind: "unary";
    input: typeof ProcessImageRequestSchema;
    output: typeof ProcessImageColorResponseSchema;
  },
  /**
   * マスク生成処理を実行する (v2)
   *
   * @generated from rpc ai_color_simulation.v1.AlColorSimulationService.GenerateMask
   */
  generateMask: {
    methodKind: "unary";
    input: typeof GenerateMaskRequestSchema;
    output: typeof GenerateMaskResponseSchema;
  },
  /**
   * Pre-warming用エンドポイント
   *
   * @generated from rpc ai_color_simulation.v1.AlColorSimulationService.WarmUp
   */
  warmUp: {
    methodKind: "unary";
    input: typeof WarmUpRequestSchema;
    output: typeof WarmUpResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ai_color_simulation_v1_al_color_service, 0);

